//
//  I13VENTCHAUFGAZCalcul.js
//
//  Created by Sébastien Hecart on 2017-11-24 14:11:01 +0000.
//  Copyright © 2017 Sebastien Hecart. All rights reserved.
//
import { I13VENTCHAUFGAZ_State } from '@batical/types/src'

function I13VENTCHAUFGAZ_docalcul(state: I13VENTCHAUFGAZ_State) {
  state.invalidated = false
  if (state.in_surfaceChaufferie > 25) {
    state.res_vhParoi = state.in_surfaceChaufferie / 10
  } else {
    state.res_vhParoi = 2.5
  }
  if (state.in_surfaceChaufferie > 12.5) {
    state.res_VB_paroi = state.in_surfaceChaufferie / 5
  } else {
    state.res_VB_paroi = 2.5
  }
  if (state.in_dnConduitChemineTirage > 5) {
    state.res_vh_gaine_ventilation = state.in_dnConduitChemineTirage / 2
  } else {
    state.res_vh_gaine_ventilation = 2.5
  }
  state.res_VB_conduite_mini = state.in_surfaceChaufferie * 10
  state.res_VB_paroi_comburant = state.in_puissanceTotal / 23
  state.res_debit_VB = state.in_puissanceTotal * 1.72

  state.res_longeurVH = Math.sqrt(state.res_vhParoi) * 100
  state.res_longeurVB = Math.sqrt(state.res_VB_paroi) * 100
  state.res_vb_comburant = Math.sqrt(state.res_VB_paroi_comburant) * 100

  //=C5*10000/C14
  state.res_hauteurVH = (state.res_vhParoi / state.in_longeurVH) * 10000
  state.res_largeurVB = (state.res_VB_paroi / state.in_longeurVB) * 10000
  if (state.ventilation_uuid === '1' || state.ventilation_uuid === '3') {
    state.res_diametreCirculaireVH = 2 * Math.sqrt(state.res_vhParoi / Math.PI) * 100
  } else {
    state.res_diametreCirculaireVH = 2 * Math.sqrt(state.res_vh_gaine_ventilation / Math.PI) * 100
  }
  //=IF(C3=1,"Diamêtre à calculer",IF(C3=3,"Diamêtre à calculer",2*SQRT(AFFICHAGE!C12/pi())*100))
  //state.res_diametreCirculaireVH = 2 * Math.sqrt(state.res_vh_gaine_ventilation / Math.PI) * 100;
  if (state.ventilation_uuid === '1') {
    state.res_diametreCirculaireVB = 2 * Math.sqrt(state.res_VB_paroi_comburant / Math.PI) * 100
  } else {
    state.res_diametreCirculaireVB = 2 * Math.sqrt(state.res_VB_paroi / Math.PI) * 100
  }
  return state
}

export default I13VENTCHAUFGAZ_docalcul
